import {
  GETVOUCHERTRANSACTIONLIST_SUCCESS,
  GETVOUCHERTRANSACTIONLIST_FAILED,
  RESET_GETVOUCHERTRANSACTIONLIST,
  LOADING_GETVOUCHERTRANSACTIONLIST,
  NETWORK_ERROR_GETVOUCHERTRANSACTIONLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetVoucherTransactionList = () => {
  return { type: RESET_GETVOUCHERTRANSACTIONLIST };
};

const getVoucherTransactionList =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETVOUCHERTRANSACTIONLIST });
    await partnerServices
      .post("getVoucherTransactionList", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.data.status) {
          case "Success":
            dispatch(getVoucherTransactionListsuccess(res.data));
            break;
          default:
            dispatch(getVoucherTransactionListFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_GETVOUCHERTRANSACTIONLIST,
          payload: err,
        });
      });
  };
function getVoucherTransactionListsuccess(data) {
  return {
    type: GETVOUCHERTRANSACTIONLIST_SUCCESS,
    payload: data,
  };
}
function getVoucherTransactionListFailed(data) {
  return {
    type: GETVOUCHERTRANSACTIONLIST_FAILED,
    payload: data,
  };
}

export { resetGetVoucherTransactionList, getVoucherTransactionList };
